/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import CollectionModule from 'client/store/modules/CollectionModule';
import CustomPolicyGroupTemplatesApi from 'client/api/v2/CustomPolicyGroupTemplatesApi';

export class CustomPolicyGroupTemplateCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();
    module.actions.setProviderId = (...params) => this.setProviderId(...params);
    return module;
  }

  /**
   * @description Set a providerId for this collection.
   */
  setProviderId(context, providerId) {
    this.Api.setProviderId(providerId);
  }
}
export default new CustomPolicyGroupTemplateCollectionClass(CustomPolicyGroupTemplatesApi, 'id', 'name').extractModule();
